import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_eye",
  "use": "svg_eye-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"svg_eye\"><path d=\"M.542 6.5S2.708 2.167 6.5 2.167c3.791 0 5.958 4.333 5.958 4.333s-2.167 4.333-5.958 4.333C2.708 10.833.542 6.5.542 6.5Z\" stroke=\"currentColor\" stroke-width=\"1.083\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M6.5 8.125a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25Z\" stroke=\"currentColor\" stroke-width=\"1.083\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol